import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import UserDateTimezone from '../../../components/user-date-timezone-format';
import { messages } from './messages';

const ShipDateColumn = ({ fulfillmentPlanId }) => {
  const fulfillmentPlanShipDate = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'shipDate',
    }),
  );
  const fulfillments = useSelector((state) =>
    Global.selectEntitiesFulfillmentsByFulfillmentPlanId(state, {
      fulfillmentPlanId,
    }),
  );
  const fulfillmentShipDateTime = fulfillments.find((f) => f.isLabelVoided === false || f.isVoided === false)?.shipDateTime;

  if (!fulfillmentPlanShipDate && !fulfillmentShipDateTime) {
    return '';
  }

  return <UserDateTimezone dateTime={fulfillmentPlanShipDate || fulfillmentShipDateTime} />;
};

ShipDateColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const ShipDate = {
  getMessageDescriptor: () => messages.shipDate,
  id: 'shipDate',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return null;
    }
    return <ShipDateColumn fulfillmentPlanId={data.id} />;
  },
};
